/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Oto_Faq_A3Inputs */

const en_simple_oto_faq_a3 = /** @type {(inputs: Simple_Oto_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You do. Everything inside it can be downloaded at any time, and the data is yours.`)
};

const id_simple_oto_faq_a3 = /** @type {(inputs: Simple_Oto_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamu. Seluruh isi aplikasi bisa diunduh kapan saja, dan datanya milikmu.`)
};

/**
* | output |
* | --- |
* | "You do. Everything inside it can be downloaded at any time, and the data is yours." |
*
* @param {Simple_Oto_Faq_A3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_oto_faq_a3 = /** @type {((inputs?: Simple_Oto_Faq_A3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Oto_Faq_A3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_oto_faq_a3(inputs)
	return en_simple_oto_faq_a3(inputs)
});